<template>
  <el-col style="text-align: center; overflow-y: scroll;padding-bottom: 100px;" class="content">

    <el-col style="width: 92%;margin-left: 4%;  font-family:'Microsoft YaHei'; text-align: left;">
      <p class="g_title">Editorial Committee</p>
      <p class="g_subtitle">Academic Advisors</p>
      <el-row style="display: flex;flex-direction: row;">
        <ul>
          <li class="ui_li">Chou, Jifan</li>
          <li class="ui_li">Jiang, Dabang</li>
          <li class="ui_li">Qin, Dahe</li>
          <li class="ui_li">Tang, Qiuhong</li>
        </ul>
        <ul style="margin-left: 50px;">
          <li class="ui_li">Ding, Yongjian</li>
          <li class="ui_li">Li, Ning</li>
          <li class="ui_li">Shi, Peijun</li>
          <li class="ui_li">Wang, Aihui</li>
        </ul>
        <ul style="margin-left: 50px;">
          <li class="ui_li">Ge, Quansheng</li>
          <li class="ui_li">Liu, Shirong</li>
          <li class="ui_li">Sun, Fubao</li>
        </ul>
        <ul style="margin-left: 50px;">
          <li class="ui_li">Gong, Peng</li>
          <li class="ui_li">Qi, Ye</li>
          <li class="ui_li">Sun, Jianqi</li>
        </ul>
      </el-row>


      <p class="g_subtitle">Academic Leaders</p>
      <el-row style="display: flex;flex-direction: row;">
        <ul>
          <li class="ui_li">Shi, Peijun</li>
        </ul>
      </el-row>



      <p class="g_subtitle">Academic Members</p>
      <el-row style="display: flex;flex-direction: row;">
        <ul>
          <li class="ui_li">Wang, Aihui</li>
          <li class="ui_li">Sun, Fubao</li>
          <li class="ui_li">Wang, Hong</li>
          <li class="ui_li">Li, Ning</li>
          <li class="ui_li">Shi, Peijun</li>
        </ul>
        <ul style="margin-left: 50px;">
          <li class="ui_li">Chen, Huopo</li>
          <li class="ui_li">Wang, Jing’ai</li>
          <li class="ui_li">Wu, Wenxiang</li>
          <li class="ui_li">Yang, Saiyi</li>
          <li class="ui_li"> Xu, Wei</li>
        </ul>
        <ul style="margin-left: 50px;">
          <li class="ui_li">Kong, Xianghui</li>
          <li class="ui_li">Yue, Yaojie</li>
          <li class="ui_li">Wu, Jidong</li>
          <li class="ui_li">Ye, Tao</li>
        </ul>
        <ul style="margin-left: 50px;">
          <li class="ui_li">Mao, Rui</li>
          <li class="ui_li">Song, Wei</li>
          <li class="ui_li">Wang, Ying</li>
          <li class="ui_li">Yang, Jianping</li>
        </ul>
        <ul style="margin-left: 50px;">
          <li class="ui_li">Yang, Jing</li>
          <li class="ui_li">Liu, Yujie</li>
          <li class="ui_li">Zhou, Hongjian</li>
          <li class="ui_li">Chen, Bo</li>
        </ul>
      </el-row>




      <p class="g_title">Leaders of Mapping Global Change Risks</p>
      <p class="g_subtitle" style="color:  #128FDC;">Environment</p>
      <p class="g_subtitle" >Mapping Environments of the World: </p>
      <el-row style="display: flex;flex-direction: row;">
        <ul>
          <li class="ui_li">Jing’ai Wang</li>
        </ul>
        <ul style="margin-left: 50px;">
          <li class="ui_li">Ying Wang</li>
        </ul>
        <ul style="margin-left: 50px;">
          <li class="ui_li">Tian Liu</li>
        </ul>
      </el-row>


      <p class="g_subtitle_blue" style="color:  #128FDC;">Global Climate Change</p>
      <p class="g_subtitle">Mapping Temperature Changes:  </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Xin Qi</li>
          <li class="ui_li_row">Miaoni Gao</li>
          <li class="ui_li_row">Siyu Li</li>
          <li class="ui_li_row">Sicheng He</li>
          <li class="ui_li_row">Jing Yang</li>
        </ul>
      </el-row>


      <p class="g_subtitle">Mapping Precipitation changes:   </p>
      <el-row style="display: flex;flex-direction: row;">
        <ul class="ui_item">
          <li class="ui_li">Aihui Wang</li>
          <li class="ui_li">Lianlian Xu</li>
          <li class="ui_li">Yue Chen</li>
        </ul>
        <ul class="ui_item">
          <li class="ui_li">Xianghui Kong</li>
          <li class="ui_li">Yue Miao</li>
          <li class="ui_li">Xianmei Lang</li>
        </ul>
        <ul class="ui_item">
          <li class="ui_li">Xiaoxin Wang</li>
          <li class="ui_li">Ju Huang</li>
        </ul>
        <ul class="ui_item">
          <li class="ui_li">Huopo Chen</li>
          <li class="ui_li">Yang Liu</li>
        </ul>
        <ul class="ui_item">
          <li class="ui_li">Dan Wan</li>
          <li class="ui_li">Ruiheng Xie</li>
        </ul>
      </el-row>



      <p class="g_subtitle">Mapping Wind Speed changes:</p>
      <el-row style="display: flex;flex-direction: row;">
        <ul class="ui_item">
          <li class="ui_li">Rui Mao</li>
          <li class="ui_li">Yufei Wang</li>
        </ul>
        <ul class="ui_item">
          <li class="ui_li">Cuicui Shi</li>
          <li class="ui_li">Guohao Liang</li>
        </ul>
        <ul class="ui_item">
          <li class="ui_li">Qi Zong</li>
        </ul>
        <ul class="ui_item">
          <li class="ui_li">Xingya Feng</li>
        </ul>
        <ul class="ui_item">
          <li class="ui_li">Yijie Sun</li>
        </ul>
      </el-row>

      <!-- -->
      <p class="g_subtitle_blue">Population and Economic System Changes</p>
      <p class="g_subtitle">Mapping global population changes: </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Yujie Liu</li>
          <li class="ui_li_row">Jie Chen</li>
        </ul>
      </el-row>

      <p class="g_subtitle">Mapping global GDP distribution: </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Fubao Sun</li>
          <li class="ui_li_row">Tingting Wang</li>
          <li class="ui_li_row">Hong Wang</li>
        </ul>
      </el-row>

      <p class="g_subtitle">Mapping global crop distribution: </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="padding-left: 0px;text-align: left;"><li class="ui_li_row">Yaojie Yue</li><li class="ui_li_row">Anyu Zhang</li></ul>
        <ul style="padding-left: 0px;text-align: left;"><li class="ui_li_row">Peng Su</li><li class="ui_li_row">Qinhua Jiang</li></ul>
        <ul style="padding-left: 0px;text-align: left;"><li class="ui_li_row">Yuan Gao</li><li class="ui_li_row">Weidong Ma</li></ul>
        <ul style="padding-left: 0px;text-align: left;"><li class="ui_li_row">Puying Zhang</li><li class="ui_li_row">Yuantao Zhou</li></ul>
        <ul style="padding-left: 0px;text-align: left;"><li class="ui_li_row">Ran Wang</li><li class="ui_li_row">Jing’ai Wang</li></ul>
      </el-row>



      <p class="g_subtitle">Mapping global industrial value added:  </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Song Wei</li>
          <li class="ui_li_row">Huiyi Zhu</li>
          <li class="ui_li_row">Han Li</li>
          <li class="ui_li_row">Qian Xue</li>
          <li class="ui_li_row">Yuanzhe Liu</li>
        </ul>
      </el-row>

      <p class="g_subtitle">Mapping global road networks of the world:   </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Wenxiang Wu</li>
          <li class="ui_li_row">Lingyun Hou</li>
        </ul>
      </el-row>


      <p class="g_subtitle">Mapping global population exposure to heatwave:  </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Qinmei Han</li><li class="ui_li_row">Wei Xu</li><li class="ui_li_row">Peijun Shi</li>
        </ul>
      </el-row>

      <p class="g_subtitle">Mapping global population exposure to rainstorms:  </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Xinli Liao</li>
          <li class="ui_li_row">Junlin Zhang</li>
          <li class="ui_li_row">Wei Xu</li>
          <li class="ui_li_row">Peijun Shi</li>
        </ul>
      </el-row>


      <p class="g_subtitle">Mapping global GDP exposure to drought:   </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Fubao Sun</li>
          <li class="ui_li_row">Tingting Wang</li>
          <li class="ui_li_row">Hong Wang</li>
        </ul>
      </el-row>

      <p class="g_subtitle">Mapping global crop exposure to extremely high temperature:</p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Yaojie Yue</li><li class="ui_li_row">Anyu Zhang </li>
        </ul>

        <ul style="padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Peng Su</li><li class="ui_li_row">Qinhua Jiang </li>
        </ul>

        <ul style="padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Yuan Gao</li><li class="ui_li_row">Weidong Ma </li>
        </ul>

        <ul style="padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Puying Zhang</li><li class="ui_li_row">Yuantao Zhou </li>
        </ul>

        <ul style="padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Ran Wang</li><li class="ui_li_row">Jing’ai Wang</li>
        </ul>
      </el-row>



      <!-- -->
      <p class="g_subtitle_blue">Global Change Risk</p>
      <p class="g_subtitle">Mapping global climate change risk of heatwave mortality: </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Qinmei Han</li><li class="ui_li_row">Weihang Liu</li>
          <li class="ui_li_row">Wei Xu</li><li class="ui_li_row">Peijun Shi</li>
        </ul>
      </el-row>

      <p class="g_subtitle">Mapping global mortality risk assessment to river floods:  </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Junlin Zhang</li>
          <li class="ui_li_row">Xinli Liao</li>
          <li class="ui_li_row">Wei Xu</li>
        </ul>
      </el-row>


      <p class="g_subtitle">Mapping global climate change risk of crop yield:   </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Weihang Liu</li>
          <li class="ui_li_row">Qingyang Mu</li>
          <li class="ui_li_row">Shuo Chen</li>
          <li class="ui_li_row">Tao Ye</li>
          <li class="ui_li_row">Peijun Shi</li>
        </ul>
      </el-row>


      <p class="g_subtitle">Mapping global GDP loss risk assessment to river floods:    </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Junlin Zhang</li>
          <li class="ui_li_row">Xinli Liao</li>
          <li class="ui_li_row">Wei Xu</li>
        </ul>
      </el-row>




      <p class="g_subtitle_blue">Chief Map Designers</p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Jing’ai Wang</li><li class="ui_li_row"> Ying Wang</li>
        </ul>
      </el-row>


      <p class="g_subtitle_blue">Map Designers</p>
      <p class="g_subtitle">Environment:  </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Tian Liu</li>
          <li class="ui_li_row">Yuanyuan Jing</li>
          <li class="ui_li_row">Yelin Sun</li>
          <li class="ui_li_row">Fanya Shi</li>
        </ul>
      </el-row>



      <p class="g_subtitle">Climate Change:  </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Tian Liu</li>
          <li class="ui_li_row">Yelin Sun</li>
          <li class="ui_li_row">Fanya Shi</li>
        </ul>
      </el-row>


      <p class="g_subtitle">Population and Economic System Changes:   </p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Yuanyuan Jing</li>
          <li class="ui_li_row">Yichen Li</li>
          <li class="ui_li_row">Qingyuan Ma</li>
        </ul>
      </el-row>

      <p class="g_subtitle">Global Change Risk:</p>
      <el-row style="display: flex;flex-direction: row;text-align: left;">
        <ul style="display: flex;flex-direction: row;padding-left: 0px;text-align: left;">
          <li class="ui_li_row">Xinli Liao</li>
          <li class="ui_li_row">Junlin Zhang</li>
          <li class="ui_li_row">Weihang Liu</li>
          <li class="ui_li_row">Qingyang Mu</li>
          <li class="ui_li_row">Shuo Chen</li>
        </ul>
      </el-row>


    </el-col>

  </el-col>
</template>

<script>
export default {
  name: "EditorialCommittee"
}
</script>

<style scoped>

.g_title{
  font-size: 36px;
  color: #324157;
  letter-spacing: 0;
  line-height: 54px;
  font-weight: bold;
}

.g_subtitle_blue{
  font-size: 26px;
  color:  #128FDC;
  letter-spacing: 0;
  margin-top: 60px;
}
.g_subtitle
{
  font-size: 26px;
  color: #324157;
  letter-spacing: 0;
}

.ui_li{
  font-size: 15px;
  color: #8A8A8A;
  letter-spacing: 0;
  text-align: justify;
  line-height: 24px;
}
.ui_li_row{
  font-size: 15px;
  color: #8A8A8A;
  letter-spacing: 0;
  text-align: justify;
  line-height: 24px;
  margin-right: 30px;
}

.ui_item{
  margin-right: 50px;
}

.content{
  text-align: left;
  font-family: "Microsoft YaHei";
}

.content::-webkit-scrollbar {
  display: none;/*隐藏滚动条*/
}
</style>




// WEBPACK FOOTER //
// src/view/BSD/About/EditorialCommittee.vue